import { cn } from '@sohanemon/utils';
import { localizeDigits } from '@sohanscript/lib/utils/format';
import { useSohanEmon } from '#/lib/hooks/sohanemon.tsx';

type ResumeRecognitionProps = React.ComponentProps<'div'>;

export function ResumeRecognition({
	className,
	...props
}: ResumeRecognitionProps) {
	const { recognition } = useSohanEmon();

	return (
		<div className={cn('space-y-3', className)} {...props}>
			{recognition.map((a) => (
				<div key={a.title}>
					<p className="font-semibold text-foreground text-xs">{a.title}</p>
					<p className="font-mono text-3xs text-primary">
						{localizeDigits(`${a.platform} · ${a.year}`)}
					</p>
					<p className="mt-0.5 text-2xs text-muted-foreground leading-snug">
						{a.note}
					</p>
				</div>
			))}
		</div>
	);
}
